import { BusinessChallengesEnum } from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageContent } from '../../application/components/ApplicationPageContent';
import BackgroundImage from '../../application/images/Section9.png';
import { ChallengeFormPageProps, challengeOptions } from './consts';
import { BusinessChallenges } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { ChallengeFormBackground } from './ChallengeFormBackground';

type FormValues = {
  thirdBusinessChallenge: BusinessChallengesEnum | null;
  thirdBusinessChallengeDescription: string | null;
};

export const OrganizationChallengeThree = (props: ChallengeFormPageProps) => {
  const { onBack, onContinue, challengeData, organizationId } = { ...props };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      thirdBusinessChallenge: challengeData?.challengeThree?.challenge as BusinessChallengesEnum,
      thirdBusinessChallengeDescription: challengeData?.challengeThree?.challengeContext,
    },
  });

  const queryClient = useQueryClient();
  const updateChallengeMutator = BusinessChallenges.useUpdateOrganizationBusinessChallenge({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(organizationId),
        });
      },
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateChallengeMutator.mutate({
      organizationId,
      data: {
        challenge: {
          challenge_number: 3,
          challenge_value: data.thirdBusinessChallenge,
          challenge_context: data.thirdBusinessChallengeDescription,
        },
      },
    });
  };

  const handleBack = () => {
    onBack();
  };

  return (
    <ChallengeFormBackground
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      onContinue={onContinue}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent title='Tell us about your third biggest challenge'>
        <FormsInputDropdown
          control={control}
          name='thirdBusinessChallenge'
          label='Third business challenge'
          placeholder='Select your third challenge'
          items={challengeOptions}
          type='default'
          error={errors.thirdBusinessChallenge}
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'thirdBusinessChallengeDescription'}
          formsError={errors.thirdBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ChallengeFormBackground>
  );
};
